import {
    createEditorUserSettingsAdapter,
    type UserSettingsStorage,
} from "@magic-md/editor-core";

const STORAGE_KEY = "magic-md:user-settings";

const storage: UserSettingsStorage = {
    async load() {
        try {
            const raw = localStorage.getItem(STORAGE_KEY);
            if (!raw) {
                return { data: {}, filePath: null, diagnostics: [] };
            }
            const parsed = JSON.parse(raw);
            return {
                data:
                    parsed && typeof parsed === "object" && !Array.isArray(parsed)
                        ? (parsed as Record<string, unknown>)
                        : {},
                filePath: null,
                diagnostics: [],
            };
        } catch {
            return { data: {}, filePath: null, diagnostics: [] };
        }
    },

    async save(data) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    },
};

export function createWebUserSettingsAdapter() {
    return createEditorUserSettingsAdapter({
        storage,
    });
}
